const array = [
  {
    path: '/administrador/privacy-policy',
    name: 'privacy_policy_adm',
    props: true,
    component: () => import('./pages/Index.vue'),
    meta: {
      layout: 'admin',
      requiresAuth: true,
      pageTitle: 'Privacy Policy',
      breadcrumb: [
        {
          text: 'Privacy Policy',
          active: true,
        },
      ],
    },
  }
]

export default array
